module.exports = __webpack_public_path__ + "static/media/header5.a7f15755.png";